import axios, { AxiosError } from 'axios';
import { Store } from '@reduxjs/toolkit';
import { logout } from '../features/authSlice';
import { api } from './api/apiClient';

let isHandlingUnauthorized = false;

function handleUnauthorized(store: Store) {
  if (isHandlingUnauthorized) {
    return;
  }

  isHandlingUnauthorized = true;
  store.dispatch(logout());
  window.location.href = '/';
}

export function setupAxiosAuthInterceptors(store: Store) {
  const onRejected = (error: AxiosError) => {
    if (error.response?.status === 401) {
      handleUnauthorized(store);
    }

    return Promise.reject(error);
  };

  axios.interceptors.response.use(response => response, onRejected);
  api.axios.interceptors.response.use(response => response, onRejected);
}
